import React from 'react';
import Icon from '../../../components/AppIcon';

const SkillEvolution = ({ skillsData }) => {
  return (
    <div className="bg-white rounded-xl shadow-premium border border-border p-6">
      <div className="flex items-center mb-6">
        <Icon name="TrendingUp" size={24} className="text-success mr-3" />
        <h3 className="text-xl font-semibold text-text-primary">Skills Evolution Timeline</h3>
      </div>

      <div className="space-y-6">
        {skillsData.map((yearData, index) => (
          <div key={index} className="relative">
            {/* Year Header */}
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mr-4">
                <span className="text-sm font-bold text-primary">{yearData.year}</span>
              </div>
              <div>
                <h4 className="font-semibold text-text-primary">{yearData.phase}</h4>
                <p className="text-sm text-text-secondary">{yearData.focus}</p>
              </div>
            </div>

            {/* Skills Grid */}
            <div className="ml-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
              {yearData.skills.map((skill, skillIdx) => (
                <div 
                  key={skillIdx}
                  className={`px-3 py-2 rounded-lg text-sm font-medium text-center transition-premium hover:scale-105 ${
                    skill.level === 'Expert' ?'bg-success/10 text-success border border-success/20'
                      : skill.level === 'Advanced' ?'bg-primary/10 text-primary border border-primary/20'
                      : skill.level === 'Intermediate' ?'bg-warning/10 text-warning border border-warning/20' :'bg-surface text-text-secondary border border-border'
                  }`}
                >
                  <div className="font-medium">{skill.name}</div>
                  <div className="text-xs opacity-75">{skill.level}</div>
                </div>
              ))}
            </div>

            {/* Connecting Line */}
            {index < skillsData.length - 1 && (
              <div className="absolute left-6 top-16 w-0.5 h-8 bg-border"></div>
            )}
          </div>
        ))}
      </div>

      {/* Current Status */}
      <div className="mt-8 p-4 bg-gradient-to-r from-primary/5 to-accent/5 rounded-lg border border-primary/10">
        <div className="flex items-center mb-2">
          <Icon name="Zap" size={20} className="text-primary mr-2" />
          <span className="font-semibold text-text-primary">Current Focus (2024)</span>
        </div>
        <p className="text-sm text-text-secondary">
          Expanding expertise in cloud architecture, AI/ML integration, and advanced React patterns. 
          Currently exploring Next.js 14, TypeScript advanced patterns, and microservices architecture.
        </p>
      </div>
    </div>
  );
};

export default SkillEvolution;